import React, {useState,useEffect} from "react";
import UpdateRegistrationForm from "./UpdateRegistrationForm";
import * as Constants from '../../../common/Constants';

const UpdateRegistrationPage = React.memo(props => {
useEffect(()=>{
   
},[]);
    function CreateDicLanguages(){
        var dic ={};
        dic.he={};
        dic.en={};
        dic.he["NewsLetterTitle"]=Constants.NewsLetterTitleHE;
        dic.he["NewsLetterSubTitle"] = Constants.NewsLetterSubTitleHE;
        dic.he["NewsLetterBtn"] =Constants.NewsLetterBtnHE;
        dic.he["ContactUsTitle"] = Constants.ContactUsTitleHE;
        
        dic.ar["NewsLetterTitle"]='الاشتراك في النشرة الإخبارية';
        dic.ar["NewsLetterSubTitle"] = 'الاطلاع على آخر المستجدات المتعلقة بالإرهاب';
        dic.ar["NewsLetterBtn"] ='التسجيل';
        dic.ar["ContactUsTitle"] = 'يرجى ترك تفاصيلك لنعاود الاتصال بك';
        
        dic.en["NewsLetterTitle"]=Constants.NewsLetterTitleEn;
        dic.en["NewsLetterSubTitle"] = Constants.NewsLetterSubTitleEn;
        dic.en["NewsLetterBtn"] =Constants.NewsLetterBtnEn;
        dic.en["ContactUsTitle"] = Constants.ContactUsTitleEN;
        
        
        if(_spPageContextInfo.webServerRelativeUrl.toLowerCase().indexOf('/he')> -1)
        {
          return dic.he;
        }
        else if(_spPageContextInfo.webServerRelativeUrl.toLowerCase().indexOf('/ar')> -1){
          return dic.ar;
        }      
        else {
          return dic.en;
        }      
      }
  

    return (
    <React.Fragment>
        <div className="news-letter-warapper news-letter-page-warapper">
        <div className="news-letter-page-title col-12 col-md-12">{props.title}</div>
            <div className="news-letter-form">
                <UpdateRegistrationForm mainURL={props.mainURL} listName={props.listName} />
            </div>
        </div>
    </React.Fragment>
    );
});
export default UpdateRegistrationPage;
